/**
 * Oferta do Decizap Go: a LP (decizap-go) manda o usuário para
 * `/decizap-go?email=...`. A rota guarda a oferta aqui e segue para o app (ou
 * para o login, com o e-mail preenchido); o MainLayout lê a oferta e abre o
 * formulário assim que o usuário estiver dentro.
 *
 * Guardar em localStorage — e não em query — é o que faz a oferta sobreviver
 * ao login, que termina com um `window.location.href` para /search ou /.
 */
const STORAGE_KEY = 'decizap_go_offer';
/** Oferta velha não abre mais: quem desistiu do login não leva o modal semanas depois. */
const OFFER_TTL_MS = 24 * 60 * 60 * 1000;
/** Worker da LP: repassa o briefing pro Google Chat do time (relay-worker/). */
export const DECIZAP_GO_RELAY = window.location.hostname.match('localhost')
    ? 'http://localhost:8787'
    : 'https://decizap-go.web-reviews.workers.dev';
export function saveDecizapGoOffer(email) {
    const offer = { email, ts: Date.now() };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(offer));
}
export function readDecizapGoOffer() {
    try {
        const offer = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
        if (offer && Date.now() - offer.ts < OFFER_TTL_MS)
            return offer;
    }
    catch (e) {
        // valor corrompido: trata como sem oferta
    }
    localStorage.removeItem(STORAGE_KEY);
    return null;
}
export function clearDecizapGoOffer() {
    localStorage.removeItem(STORAGE_KEY);
    // O beforeEnter do /login grava o pathname de origem em `redirect`; sem
    // limpar, o InfosetsGuard mandaria o usuário de volta pra /decizap-go depois.
    if (localStorage.getItem('redirect') === '/decizap-go') {
        localStorage.removeItem('redirect');
    }
}
